import React, { useMemo, useState, useEffect } from "react";
import PageName from "../../components/PageName";
import Card from "../../components/Base/Card";
// import { FiChevronDown, FiDownloadCloud } from "react-icons/fi";
// import BaseDateRangePicker from "../../components/Base/BaseDateRangePicker";
import BaseFilter from "../../components/Base/BaseFilter";
import { Table } from "../../components/Base/BaseTable";
import { BsBoxArrowUpRight } from "react-icons/bs";
import {formatCurrency, truncateString} from "../../utils";
import TransactionSummaryModal from "../../components/TransactionSummaryModal";
import NoTransactionImage from "../../assets/images/no-transactions.png";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getTransactionHistory } from "../../redux/transactions/transactionSlice";
import LoadingSpinner from "../../components/LoadingSpinner";
import { downloadStatement } from "../../redux/statement/statementSlice";
import {TransactionI} from "../../interfaces";
import {format, parseISO} from "date-fns";
import TimeOutActivityLayout from "../auth/inactivity-timeout-v2";

export function DateRangeColumnFilter({
                                        column: { filterValue = [], preFilteredRows, setFilter, id }}: { column:any})
{
  const [min, max] = React.useMemo(() => {
    let min: Date = new Date(preFilteredRows[0].values[id])
    let max: Date = new Date(preFilteredRows[0].values[id])
    preFilteredRows.forEach((row: any)=> {
      min = new Date(row.values[id]) <= min ? new Date(row.values[id]) : min
      max = new Date(row.values[id]) >= max ? new Date(row.values[id]) : max
    });
    return [min, max];
  }, [id, preFilteredRows]);
  console.log(min, max)
  return (
    <div
      style={{
        display: "flex"
      }}
    >
      <input
        value={filterValue[0] || ""}
        type="date"
        min={min.toISOString().slice(0, 10)}
        onChange={e => {
          const val = e.target.value;
          console.log(e.target.value);
          setFilter((old = []) => [val ? (val) : undefined, old[1]]);
        }}
        style={{
          width: "170px",
          marginRight: "0.5rem"
        }}
      />
      to
      <input
        value={filterValue[1] || ""}
        type="date"
        max={max.toISOString().slice(0, 10)}
        onChange={e => {
          const val = e.target.value;
          setFilter((old = []) => [old[0], val ? (val) : undefined]);
        }}
        style={{
          width: "170px",
          marginLeft: "0.5rem"
        }}
      />
    </div>
  );
}

const initialTransaction = {
  employerContribution: 0,
  employeeContribution: 0,
  voluntaryContribution: 0,
  withdrawal: 0,
  withdrawalFromVoluntary: 0,
  contributionDate: "",
  valueDate: "",
  fee: 0,
  narration: "",
  description: "",
  totalContribution: ""
};

const Transactions = () => {
  const [filterValue, setFilterValue] = useState("");
  const [startDate, setStartDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const [transactionSummary, setShowTransactionSummary] = useState(false);
  const [currentTransaction, setCurrentTransaction] = useState<TransactionI>(initialTransaction);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getTransactionHistory());
  }, []);

  const { isLoading, isSuccessful, transactions } = useAppSelector(
    (state) => state.transactions
  );

  const setDateRangeHandler = (dates: Date[]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const toggleShowTransactionSummary = () =>
    setShowTransactionSummary(!transactionSummary);

  const showSummary = (summary: TransactionI) => {
    setCurrentTransaction(summary);
    toggleShowTransactionSummary();
  };

  const handleDownloadStatement = (e: any) => {
    e.preventDefault();
    dispatch(downloadStatement());
  };

  const columns: any = useMemo(
    () => [
      {
        Header: "#",
        accessor: "",
        // @ts-ignore
        Cell: ({ cell: { row } }) => <>{parseInt(row.id, 10)+1}</>,
      },
      {
        Header: "Employer Name",
        accessor: "employerName",
        // @ts-ignore
        Cell: ({ cell: { value } }) => <>{truncateString(value, 25)}</>,
      },
      {
        Header: "Description",
        accessor: "description",
      },
      {
        Header: "Total Contribution",
        accessor: "totalContribution",
        // @ts-ignore
        Cell: ({ cell: { value } }) => <>&#8358;{formatCurrency(value)}</>,
      },
      {
        Header: "Withdrawal",
        accessor: "withdrawal",
        // @ts-ignore
        Cell: ({ cell: { value } }) => <>&#8358;{value && value.length > 0 ? formatCurrency(value.toString()) : ""}</>,
      },
      {
        Header: "Date Paid",
        accessor: "contributionDate",
        Filter: DateRangeColumnFilter,
        filter: "contributionDate",
        // @ts-ignore
        Cell: ({ cell: { value } }) => <>{format(parseISO(value), "yyyy-MM-dd")}</>,
      },
      {
        Header: "Action",
        accessor: "",
        // @ts-ignore
        Cell: ({ row: { original } }) => {
          return (
            <button
              className="btn table-action-btn"
              onClick={() => {
                showSummary(original)
              }}
            >
              <BsBoxArrowUpRight className="font-bold text-lg mr-2" />
              View More
            </button>
          );
        },
      },
    ],
    []
  );

  const tableData: any = useMemo(
    () => transactions,
    [transactions]
  );


  return (
    <TimeOutActivityLayout>
    <div className="transaction-page">
      <TransactionSummaryModal
        showModal={transactionSummary}
        onClose={toggleShowTransactionSummary}
        transaction={currentTransaction}
      />
      <PageName pageName={"Transactions"} />
      <div className="transaction">
        <Card className="transaction-card">
          <div className="h1 text-grayscaleBody border-b pb-4">
            Transaction History
          </div>
          {/*
          <div className="flex justify-end mt-10">
            <button
              className="btn btn-outline btn-b"
              onClick={handleDownloadStatement}
            >
              {
                  isLoading
                      ?
                      <LoadingSpinner />
                      :<>
                          <FiDownloadCloud className="text-xl mr-4" />
                          Download
                      </>
              }
            </button>
          </div>
          */}
          <div className="mt-10 table-filter-group">
            <div className="table-filter">
              <BaseFilter
                value={filterValue}
                onChange={(val) => setFilterValue(val)}
              />
              {/*
              <BaseDateRangePicker
                className="mt-4 sm:mt-0 max-w-full  sm:max-w-[328px] sm:ml-4"
                onChange={(date) => setDateRangeHandler(date)}
              />
              */}
              {/*
              <div>
                <button className="btn btn-outline btn-b">Continue</button>
              </div>*/}
            </div>
            {/*
            <div className="table-sort">
              <button className="btn btn-outline btn-b">
                Sort
                <FiChevronDown className="ml-2 " />
              </button>
            </div>
            */}
          </div>
          {!isLoading && isSuccessful ? (
            tableData?.length ? (
              <div className="mt-10">
                {/*@ts-ignore*/}
                <Table
                 showPagination={false}
                  filterValue={filterValue}
                  columns={columns}
                  data={tableData}
                />
              </div>
            ) : (
              <div className="no-transaction">
                <img
                  src={NoTransactionImage}
                  alt=""
                  className="no-transaction__img"
                />
                <div className="no-transaction__text">
                  No transaction history
                </div>
                {/* <div className="no-transaction__info">
                  Select a date range to continue
                </div> */}
              </div>
            )
          ) : (
            <div className="table-loading">
              <LoadingSpinner size={"lg"} />
            </div>
          )}
        </Card>
      </div>
    </div>
    </TimeOutActivityLayout>
  );
};
export default Transactions;
